import { Component as ReactComponent } from 'react'

import Project from '../models/Project'
import Team from '../models/Team'
import User from '../models/User'
import TalentCandidate from "../models/TalentCandidate";


export default class Component extends ReactComponent
{
	/**
     * [Notes]
     *
     * @param {Object} props
     * @param context
     * @returns void
     */
	constructor(props, context = undefined)
	{
		super(props, context)

		this.state = {
			//
		};
	}

	/**
     * [Notes]
     *
     * @returns void
     */
	componentDidMount()
	{
        this._isMounted = true;

        TB.event().bindComponent(this);
	}

    /**
     * [Notes]
     *
     * @returns void
     */
    promisedState(updates)
    {
        if (!this._isMounted) {
            return;
        }

        return new Promise(resolve => {
            this.setState(updates, resolve);
        });
    }

    static async parseRequestError(request, appendErrorKey)
    {
        let statusCode = request?.statusCode() || 403,
            errorKey = request?.errorMessage?.();
        if (!TB.trans(`api`)[errorKey]) {
            errorKey = 'server_error';
        }


        let titleLines = [
            TB.trans(`api.${errorKey}.title`),
        ];


        if (TB.isObject(appendErrorKey)) {
            appendErrorKey = appendErrorKey[statusCode]
                ? appendErrorKey[statusCode]
                : appendErrorKey[500];
        }

        if (appendErrorKey && TB.trans(`api`)[appendErrorKey]) {
            titleLines.push(TB.trans(`api.${appendErrorKey}`))
        }

        return {
            title: titleLines,
            message: TB.trans(`api.${errorKey}.message`, {code: statusCode || ''}),
        };
    }
    /**
     * [Notes]
     *
     * @returns {Int} errorCode
     * @returns Promise
     */
    async handleErrorResponse(request, appendErrorKey)
    {
        if (!this._isMounted) {
            return;
        }

        let error = await Component.parseRequestError(request, appendErrorKey)

        await this.promisedState({error})

        if (!this._isMounted) {
            return;
        }

        await this.promisedState({
            isLoading: false,
        });
    }

    async fetchProject(projectId)
    {
        if (this.state.error) {
            Project.clearCache();
        }

        await this.promisedState({
            project: undefined,
            isLoading: true,
            error: null,
        });

        let project = await Project.fetchForClient(
            projectId
        );
        if (!project) {
            return this.handleErrorResponse(
                Project.FetchAllRequest, {
                    500: 'error_show_project',
                    404: 'error_project_not_found',
                }
            );
        }

        // console.log(project);
        await this.promisedState({project});

        return project;
    }

    async fetchTeam(teamId, project, refresh = false)
    {
        if (this.state.error) {
            Team.clearCache();
        }

        await this.promisedState({
            team: undefined,
            isLoading: true,
            error: null,
        });

        let team = await Team.find(
            teamId, project, refresh
        );

        if (!team) {
            return this.handleErrorResponse(
                Team.FetchRequest, {
                    500: 'error_show_team',
                    404: 'error_team_not_found',
                }
            );
        }

        await this.promisedState({team});

        return team;
    }

    async fetchTalent(userId, params = {}, requestOptions = {})
    {
        await this.promisedState({
            talent: undefined,
            isLoading: true,
            error: null,
        });

        let user = await User.fetchTalent(userId, params, requestOptions);
        if (!user) {
            throw new Error("Something went wrong")
        }

        let talent = user;
        if(this.props.candidate) {
            talent = TalentCandidate.make({...user, ...this.props.candidate})
        }
        await this.promisedState({talent});

        return talent;
    }

    /**
     * [Notes]
     *
     * @returns void
     */
    componentWillUnmount()
    {
        this._isMounted = false;

        TB.event().unbindComponent(this);
    }
}